import { Const } from '~/constants/Const.constant';
import { battery } from '~/helpers/fields-description';
import { VeluxModule } from '~/models/modules/velux/VeluxModule.model';

export class NXS extends VeluxModule {

    battery_levels = {
        full: Const.NABatteryLevelNXS.NXS_LEVEL_0,
        high: Const.NABatteryLevelNXS.NXS_LEVEL_1,
        medium: Const.NABatteryLevelNXS.NXS_LEVEL_2,
        low: Const.NABatteryLevelNXS.NXS_LEVEL_3,
    };

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
}
